import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "app-error-overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "app-error-overlay-title" }, "Unable to load weather data", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "app-error-overlay-subtitle" }, [
  /*#__PURE__*/_createTextVNode("Please check your connection."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("The app will retry automatically.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        })),
    (_ctx.dataError && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("button", {
            ref: "retryButton",
            class: "app-error-overlay-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryLoad && _ctx.retryLoad(...args)))
          }, "Retry now", 512)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}